import { flexRender } from "@tanstack/react-table";
import React from "react";
import useOverflowCheck from "../../../student_credits_manage/hooks/useOverflowCheck";
import Tooltip from "../../../../components/shared/Tooltip/Tooltip";

const Cell = ({ cell }) => {
  const value = flexRender(cell.column.columnDef.cell, cell.getContext());

  const { isOverflowing, tagRef, textRef, width } = useOverflowCheck({
    dependency: value,
  });

  return (
    <td className="relative">
      <div className="px-2 text-start" ref={tagRef}>
        <Tooltip
          content={
            isOverflowing &&
            cell.getValue() &&
            !cell?.id?.includes("videoPath") ? (
              <span className="text-sm text-white">{value}</span>
            ) : (
              ""
            )
          }
          placement="top"
        >
          <span
            className="inline-block truncate"
            ref={textRef}
            style={{
              maxWidth: width ? `${width - 8}px` : "100%",
            }}
          >
            {value}
          </span>
        </Tooltip>
      </div>

      <div className="bg-gray200 absolute top-0 right-0 h-full w-px" />
    </td>
  );
};

export default Cell;
